import {makeEnumRuntimeType} from '../../models/api/apiTypes';

/*
 * Types.
 */

export enum EmailFormatsEnum {
  HTML = 'html',
  MARKDOWN = 'markdown',
}

/*
 * Runtime types.
 */

export const REmailFormats = makeEnumRuntimeType(EmailFormatsEnum);
